<template>
    <section id="gallery-section" class="py-1">
        <div class="custom-container">
            <Carousel
                style="max-width: 800px;"
                :images="images"
                :autoSlideInterval="3000"
            ></Carousel>
        </div>
    </section>
</template>

<script>
import Carousel from '../../global-components/Carousel.vue';

export default {
    components: {
        Carousel
    },
    props: {
        gallery: String
    },
    data () {
        return {
            images: []
        }
    },
    mounted () {
        const webData = JSON.parse(this.gallery)
        this.images = webData.images
    }
}

</script>